import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as LayerActions from '~app/actions/layers';

class ContinuousTimeline extends Component {

  static propTypes = {
    maps: PropTypes.array,
  }

  constructor(props) {
    super(props);

    // Execute the binding of the methods only once.
    // Then when we call add/removeEventListener, we know we are actually removing
    // the same function that we added earlier.
    this._scrub = ::this.scrub;
    this._stopScrub = ::this.stopScrub;
  }

  selectButton(index) {
    this.props.setMapIndex(index);
  }

  startScrub() {
    // Attach the listeners to the document (instead of one of our elements)
    // to make sure we allow scrubbing outside the timeline container and also
    // stop the scrub even if the mouseup event occurs outside of our timeline
    // container.
    document.addEventListener("mousemove", this._scrub);
    document.addEventListener("mouseup", this._stopScrub);
  }

  stopScrub() {
    document.removeEventListener("mousemove", this._scrub);
    document.removeEventListener("mouseup", this._stopScrub);
  }

  scrub(event) {
    const buttons = this.getButtons();
    for (const [index, button] of buttons.entries()) {
      if (this.buttonContainsEvent(button, event)) {
        if (index !== this.props.activeMapIndex) {
          this.selectButton(index);
        }
        break;
      }
    }
  }

  getButtons() {
    const domContainer = this.refs.buttonContainer;
    return Array.from(domContainer.children);
  }

  buttonContainsEvent(button, event) {
    const buttonRect = button.getBoundingClientRect();
    // Only check the horizontal bounds to allow full-screen scrubbing.
    return (buttonRect.left <= event.clientX &&
            buttonRect.right >= event.clientX);
  }

  renderContinuousTimelineButton(mapDef, index) {
    return (
      <button
        key={mapDef.name}
        className={classNames("ContinuousTimeline__button", {
          "ContinuousTimeline__button--highlighted": index === this.props.activeMapIndex,
          "ContinuousTimeline__button--first": index === 0,
        })}
        onMouseDown={() => {
          this.selectButton(index);
          this.startScrub();
        }}
      >
        {mapDef.displayName}
      </button>
    );
  }

  render() {
    return (
      <div className="ContinuousTimeline" ref="buttonContainer">
        {this.props.maps.map(::this.renderContinuousTimelineButton)}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  maps: state.layer.layers[state.layer.activeLayerIndex].maps,
  activeMapIndex: state.layer.activeMapIndex,
});

const mapDispatchToProps = {
  setMapIndex: LayerActions.setMapIndex,
};

export { ContinuousTimeline };
export default connect(mapStateToProps, mapDispatchToProps)(ContinuousTimeline);



// WEBPACK FOOTER //
// ./src/components/ContinuousTimeline.js